import React from 'react';
import { SITE_CONTENT } from '../constants';

const Maestro: React.FC = () => {
  const { maestro } = SITE_CONTENT;
  const [src, setSrc] = React.useState(maestro.image);
  const fallback = "https://images.unsplash.com/photo-1459749411177-042180ce673c?q=80&w=2070&auto=format&fit=crop";

  return (
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        {/* Colonna Immagine - Resa sticky su desktop per bilanciare il testo lungo */}
        <div className="lg:col-span-5 lg:sticky lg:top-40">
          <div className="relative">
            {/* Cornice esterna decorativa (uguale a quella della tecnica) */}
            <div className="absolute -inset-4 border border-gold/20" />
            
            {/* Contenitore Immagine */}
            <div className="relative z-10 w-full aspect-[4/5] lg:h-[700px] bg-slate-800 overflow-hidden shadow-2xl">
              <img 
                src={src} 
                alt={maestro.name} 
                className="w-full h-full object-cover"
                onError={() => src !== fallback && setSrc(fallback)}
              />
            </div>

            {/* Label Maestro */}
            <div className="absolute -bottom-6 -right-6 z-20 bg-gold p-8 text-midnight shadow-2xl transform hover:-translate-y-1 transition-transform duration-300">
              <span className="block uppercase tracking-widest text-xs mb-1">Direzione Artistica</span>
              <span className="block font-serif text-2xl">{maestro.name}</span>
            </div>
          </div>
        </div>

        {/* Colonna Testo */}
        <div className="lg:col-span-6 lg:col-start-7 mt-12 lg:mt-0">
          <h2 className="text-4xl md:text-5xl font-serif text-white mb-8">
            {maestro.title}
          </h2>
          <div className="w-20 h-px bg-gold mb-8" />
          
          {/* Slogan Iniziale */}
          <p className="text-xl text-gold-light italic font-serif mb-10 leading-relaxed">
            "La musica non è solo note, ma lo spazio tra di esse, dove l'anima trova il suo respiro."
          </p>
          
          {/* Biografia Dettagliata con gestione dei ritorni a capo */}
          <div className="text-lg text-white/90 leading-relaxed whitespace-pre-line space-y-4">
            {maestro.bio}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maestro;